// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { LoginResponseSuccessFragmentDoc } from './loginResponseSuccess.generated';
import { LoginResponseFailureFragmentDoc } from './loginResponseFailure.generated';
export const LoginResponseFragmentDoc = gql`
    fragment loginResponse on LoginResponse {
  ... on LoginResponseSuccess {
    ...loginResponseSuccess
  }
  ... on LoginResponseFailure {
    ...loginResponseFailure
  }
}
    ${LoginResponseSuccessFragmentDoc}
${LoginResponseFailureFragmentDoc}`;